interface WindowWithZendesk extends Window {
  zE: {
    activate: () => void;
    hide: () => void;
    show: () => void;
  };
}
export function openZendeskWidget() {
  if (window && 'zE' in window) {
    (window as unknown as WindowWithZendesk).zE.activate();
    return true;
  }
  return false;
}
